import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { Dropdown } from "../../../common/Dropdown/Dropdown";
import InputField from "../../../common/InputField/InputField";
import {
  SearchWrapper,
  SearchModeContainer,
  SearchContainer,
} from "./SearchForm.styles";

export const SearchForm = ({
  searchMode,
  answerIdQuery,
  emailQuery,
  selectedOrgId,
  handleSearchModeChange,
  handleAnswerIdChange,
  handleEmailChange,
  handleOrgSelect,
  organizations,
}) => {
  const { t } = useTranslation();

  // Search mode options
  const searchModeOptions = useMemo(
    () => ({
      answerId: t("logs.searchByAnswerId"),
      email: t("logs.searchByUserEmail"),
      organization: t("logs.searchByOrganization"),
    }),
    [t]
  );

  // Create organization options for dropdown
  const orgOptions = useMemo(() => {
    return organizations.reduce((acc, org) => {
      acc[org.id] = org.name;
      return acc;
    }, {});
  }, [organizations]);

  // Render search input based on current search mode
  const renderSearchInput = useMemo(() => {
    switch (searchMode) {
      case "answerId":
        return (
          <InputField
            placeholder={t("logs.searchByAnswerId")}
            value={answerIdQuery}
            onChange={handleAnswerIdChange}
          />
        );
      case "email":
        return (
          <InputField
            placeholder={t("logs.searchByUserEmail")}
            value={emailQuery}
            onChange={handleEmailChange}
          />
        );
      case "organization":
        return (
          <Dropdown
            label={t("logs.selectOrganization")}
            options={orgOptions}
            defaultSelected={selectedOrgId}
            handleSelect={handleOrgSelect}
            allowFiltering={true}
            filterPlaceholder={t("logs.filterOrganizations")}
          />
        );
      default:
        return null;
    }
  }, [
    searchMode,
    t,
    answerIdQuery,
    handleAnswerIdChange,
    emailQuery,
    handleEmailChange,
    orgOptions,
    selectedOrgId,
    handleOrgSelect,
  ]);

  return (
    <SearchWrapper>
      <SearchModeContainer>
        <Dropdown
          label={t("logs.searchMode")}
          options={searchModeOptions}
          defaultSelected={searchMode}
          handleSelect={handleSearchModeChange}
        />
      </SearchModeContainer>

      <SearchContainer>{renderSearchInput}</SearchContainer>
    </SearchWrapper>
  );
};
